import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { InvestmentBudgetCard } from './types';
import { formatMoney, formatNumber } from './format';

type Props = { cards: InvestmentBudgetCard | null };

const InvestmentBudgetCardsPanel: React.FC<Props> = ({ cards }) => {
  const items = [
    ['Lines', formatNumber(cards?.linecount)],
    ['Cost Centers', formatNumber(cards?.costcentercount)],
    ['Types', formatNumber(cards?.typecount)],
    ['Requested', formatMoney(cards?.requestedamount)],
    ['Approved', formatMoney(cards?.approvedamount)],
    ['Variance', formatMoney(cards?.variance)],
  ];

  return (
    <Grid container spacing={2}>
      {items.map(([label, value]) => (
        <Grid size={{ xs: 12, sm: 6, md: 3 }} key={label}>
          <Card elevation={2}>
            <CardContent>
              <Typography variant="caption" color="text.secondary">{label}</Typography>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>{value}</Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default InvestmentBudgetCardsPanel;
